import React, { Component } from "react";
import PropTypes from "prop-types";
import Checkbox from "material-ui/Checkbox";
import { DragSource, DropTarget } from "react-dnd";
import ItemTypes from "./ItemTypes";

const itemSource = {
  beginDrag(props) {
    return {
      id: props.id,
      originalIndex: props.findItem(props.id).index
    };
  },

  endDrag(props, monitor) {
    const { id: droppedId, originalIndex } = monitor.getItem();
    const didDrop = monitor.didDrop();

    if (!didDrop) {
      props.moveItem(droppedId, originalIndex);
    }
  }
};

const itemTarget = {
  canDrop() {
    return false;
  },

  hover(props, monitor) {
    const { id: draggedId } = monitor.getItem();
    const { id: overId } = props;

    if (draggedId !== overId) {
      const { index: overIndex } = props.findItem(overId);
      props.moveItem(draggedId, overIndex);
    }
  }
};

const dropTarget = connect => ({
  connectDropTarget: connect.dropTarget()
});
const dragSource = (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging()
});

class Item extends Component {
  render() {
    const {
      id,
      title,
      index,
      choices,
      isDragging,
      isSelected,
      isChecked,
      changeUseAttrs,
      connectDragSource,
      connectDropTarget,
      selectItem,
      movable,
      isEdit,
      classes,
      dept
    } = this.props;
    const opacity = isDragging ? 0.3 : 1;
    const selectedStyle =
      isSelected && isEdit
        ? {
          backgroundColor: "#26a69a",
          color: "#FFF"
        }
        : {
          backgroundColor: "transparent",
          color: "#1e1845"
        };
    const cursor = movable && isEdit ? "move" : "default";
    if (movable && isEdit) {
      return connectDragSource(
        connectDropTarget(
          <div
            role="button"
            id={id}
            tabIndex={id}
            onClick={selectItem}
            onKeyPress={selectItem}
            className={classes.addButton}
            style={{
              opacity,
              ...selectedStyle,
              cursor
            }}
          >
            {`Q${id} ${title}`}
          </div>
        )
      );
    }
    return (
      <div
        id={id}
        tabIndex={id}
        className={classes.addButton}
        style={{
          opacity,
          ...selectedStyle,
          cursor,
          display: "inline-flex",
          alignItems: "center",
          width: 920
        }}
      >
        <Checkbox
          style={{
            height: 24,
            width: 24
          }}
          disabled={dept}
          checked={isChecked}
          color="primary"
          onClick={event => changeUseAttrs(event, index - 1)}
        />
        <div style={{ marginLeft: 20, width: 30 }}>{index}</div>
        <div style={{ marginLeft: 20, width: 200 }}>{title}</div>
        <div style={{ marginLeft: 20, width: 640 }}>{choices}</div>
      </div>
    );
  }
}

Item.propTypes = {
  connectDragSource: PropTypes.func.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired,
  id: PropTypes.any.isRequired,
  title: PropTypes.string.isRequired,
  moveItem: PropTypes.func.isRequired,
  findItem: PropTypes.func.isRequired
};
export default DragSource(ItemTypes.ITEM, itemSource, dragSource)(
  DropTarget(ItemTypes.ITEM, itemTarget, dropTarget)(Item)
);



// WEBPACK FOOTER //
// ./src/components/CreateSurvey/SelectAttr/Item.jsx